<div class="mb-12">
  <h2 class="mb-4 text-lg tracking-wider text-primary-500 md:text-xl">
    {{ ("impactReport.impactPerDay" | transloco).toLocaleUpperCase() }}
  </h2>
  @if (showChart) {
    <p-chart
      type="bar"
      [data]="data"
      [options]="options"
      [plugins]="plugins"
      [height]="height + 'px'"
    />
  }
</div>
